module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerpref01",
      "epub:type": "preface",
      "id": "pref",
      "role": "doc-preface"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerpref01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ix",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiseneca0005#rpref"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The surviving manuscripts of Seneca’s "), _c('i', [_vm._v("Letters on Ethics")]), _vm._v(" contain no fewer than 124 letters, ranging in length from a single page to fifteen or more. Seneca writes about so many subjects and in so many different styles that any selection is bound to be partial, since every letter adds something fresh about the author’s extraordinary mind and literary virtuosity. Nonetheless, in choosing fifty letters for this volume, we have tried to illustrate the range and variety of Seneca’s subject matter, from the experiences of his daily life—the noisy neighbors, the footrace with a little child, the roar of a packed arena—to his intellectual interests in literature and philosophy. Our explanatory notes supply fuller information on people, places, and ideas mentioned in the text. These notes are adapted from the much longer commentary in our complete edition of the "), _c('i', [_vm._v("Letters on Ethics")]), _vm._v(" (Graver and Long 2015), with expansion at some points to serve the needs of readers who may be meeting Seneca for the first time. An asterisk in the main text (*) indicates an "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiseneca0059#notes-aster"
    }
  }, [_vm._v("explanatory note")]), _vm._v(" at the back of the book.")]), _vm._v(" "), _c('p', [_vm._v("Apart from one or two minor revisions, the translation given here is identical to the one in our earlier book. The Latin text followed is that of Reynolds (1965b). In those few places where we differ from Reynolds as to what Latin text best represents Seneca’s intentions, the word or phrase that renders the different Latin wording is marked with a superscript circle ("), _c('sup', [_vm._v("°")]), _vm._v("), and our reading is given in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiseneca0060#notes-circle"
    }
  }, [_vm._v("Textual Notes")]), _vm._v(" section. The translation itself aims primarily to convey Seneca’s ideas exactly, while also conveying his ever-changing style and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "x",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _vm._v("mood. Although word-for-word rendering is rarely possible (and would often be misleading), we do strive for consistency in translating key Latin words, taking pains especially with philosophical terms.")]), _vm._v(" "), _c('p', [_vm._v("In preparing the explanatory notes, we have relied mainly on our own judgment, but we are often indebted to earlier commentators for assistance in locating the relevant ancient evidence. For historical and biographical matters, we have frequently consulted the comprehensive "), _c('i', [_vm._v("Brill’s New Pauly")]), _vm._v(" (Cancik and Schneider 2002–10). Portions of the translation and notes have been improved as well by the acumen of undergraduate research assistants funded through the James O. Friedman Presidential Scholars Program at Dartmouth College: Brian Howe, John Kee, Michael Konieczny, Karen Laakko, Aaron Pellowski, Lea Schroeder, and Leslie Shribman.")]), _vm._v(" "), _c('p', [_vm._v("The titles given to individual letters are supplied by us for ease of reference; they are not authorial.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a88e0b7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-seneca-0006.vue
// module id = 69
// module chunks = 0